import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root',
})
export class AdminControlService {
  constructor(
    private http: HttpClient,
    private ngxLoader: NgxUiLoaderService,
    private message: NzMessageService,
  ) {}

  getControls(): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.get(`${SETTINGS.CMS_API}/api/globals/admin-control`, {withCredentials: true}).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to retrieve Admin Controls');
          reject(error);
        },
      );
    });
  }

  updateMemberLog(data: any): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .post(`${SETTINGS.CMS_API}/api/globals/admin-control`, data,
          {withCredentials: true}
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to Update Member Log');
            reject(error);
          },
        );
    });
  }
}
